import { render, staticRenderFns } from "./ManufactureAndExpirationInfo.vue?vue&type=template&id=760dd087&"
import script from "./ManufactureAndExpirationInfo.vue?vue&type=script&lang=ts&"
export * from "./ManufactureAndExpirationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports